import { SimpleGrid, SimpleGridProps } from "@chakra-ui/layout";
import { motion } from "framer-motion";

export const MotionSimpleGrid = motion<SimpleGridProps>(SimpleGrid);
